{
  "name": "@monorepo/app",
  "private": true,
  "version": "1.0.0",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "check": "tsgo -b",
    "check-watch": "tsgo -b --watch",
    "build": "vite build --mode production",
    "preview": "vite preview",
    "lint": "biome lint",
    "lint:fix": "biome lint --fix .",
    "test": "vitest run",
    "test:watch": "vitest",
    "i18n:extract-po": "node scripts/extract-to-po.mjs",
    "i18n:report-defaults": "node scripts/report-i18n-defaults.mjs",
    "i18n:po-to-json": "node scripts/po-to-json.mjs",
    "i18n:sync": "npm run i18n:extract-po && npm run i18n:po-to-json",
    "i18n:sync-defaults": "node scripts/po-to-json.mjs && node scripts/update-i18n-defaults.mjs",
    "shutdown": "kill -9 `lsof -t -i:3000`"
  },
  "dependencies": {
    "@dnd-kit/dom": "^0.5.0",
    "@dnd-kit/helpers": "^0.5.0",
    "@dnd-kit/react": "^0.5.0",
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.0",
    "@fontsource/roboto": "^5.3.0",
    "@fullcalendar/core": "^6.1.21",
    "@fullcalendar/daygrid": "^6.1.21",
    "@fullcalendar/interaction": "^6.1.21",
    "@fullcalendar/react": "^6.1.21",
    "@fullcalendar/resource": "^6.1.21",
    "@fullcalendar/resource-timeline": "^6.1.21",
    "@hookform/resolvers": "^5.9.1",
    "@mui/icons-material": "^9.4.0",
    "@mui/material": "^9.4.0",
    "@mui/system": "^9.4.0",
    "@mui/utils": "^9.4.0",
    "@mui/x-charts": "^9.14.0",
    "@mui/x-data-grid": "^9.14.0",
    "@mui/x-date-pickers": "^9.14.0",
    "@sentry/react": "^10.75.0",
    "@tanstack/react-query": "^5.103.1",
    "@tanstack/react-router": "^1.170.38",
    "axios": "^1.20.0",
    "date-fns": "^4.4.0",
    "i18next": "^26.4.2",
    "immer": "^11.1.18",
    "lodash": "^4.17.21",
    "mui-tel-input": "^11.0.0",
    "react": "^19.3.0",
    "react-dom": "^19.3.0",
    "react-hook-form": "^7.88.0",
    "react-i18next": "^17.0.14",
    "yup": "^1.6.1"
  },
  "devDependencies": {
    "@biomejs/biome": "2.5.14",
    "@sentry/vite-plugin": "^5.4.0",
    "@tanstack/react-query-devtools": "^5.103.1",
    "@tanstack/react-router-devtools": "^1.167.2",
    "@tanstack/router-plugin": "^1.168.40",
    "@types/react": "^19.3.0",
    "@types/react-dom": "^19.3.0",
    "@typescript/native-preview": "7.0.0-dev.20260707.2",
    "@vitejs/plugin-react": "^6.1.1",
    "@vitest/coverage-v8": "^5.0.1",
    "gettext-extractor": "^4.0.1",
    "gettext-parser": "^9.1.1",
    "globals": "^17.12.0",
    "i18next-cli": "^1.74.1",
    "i18next-conv": "^17.0.0",
    "playwright": "^1.63.0",
    "prop-types": "^15.8.1",
    "vite": "^8.3.0",
    "vite-plugin-compression2": "^2.5.3",
    "vite-plugin-svgr": "^5.2.0",
    "vitest": "^5.0.1"
  }
}
